import React from 'react'
import { useTranslation } from 'react-i18next'

export const Footer = () => {
    const { t } = useTranslation()

    return (
        <div>
            <br /><br />
            <footer className='element-footer'>
                <a href="/terms" className="element-form-label" style={{ color: "white" }}>{t('footer.termsConditions')}</a> |
                <a href="/privacity" className="element-form-label" style={{ color: "white" }}>{t('footer.privacy')}</a> |
                <a href="/" className="element-form-label" style={{ color: "white" }}>{t('footer.contact')}</a> |
                <a href="/" className="element-form-label" style={{ color: "white" }}>@2021Element Fleet Management Corp.,{t('footer.rigths')} </a>
            </footer>
        </div>

    )
}
